import React from "react";
import V2sContainer from "containers/V2sContainer";
import { Button, Container, Heading, VStack } from "@chakra-ui/react";
import IncentivesBanner from "components/IncentivesBanner";
import V1sContainer from "containers/V1sContainer";
import Panel from "components/Panel";
import ReserveProcessContainer from "components/ReserveProcessContainer";
import useTranslate from "hooks/useTranslate";
import { v1Name, v2Name } from "config";

const NftsPage: React.FC = () => {
  const translate = useTranslate();

  return (
    <VStack pt="12" pb="16" spacing="6">
      <Container>
        <IncentivesBanner />
      </Container>

      <V2sContainer />

      <V1sContainer />

      <Container maxW="md">
        <Panel p="6" px="8" textAlign="center">
          <Heading size="sm" mb="4" lineHeight="base">
            {translate("nfts:reserve:info", { v1Name, v2Name })}
          </Heading>

          <ReserveProcessContainer
            trigger={
              <Button size="sm" colorScheme="dark">
                {translate("nfts:reserve:trigger", { v2Name })}
              </Button>
            }
          />
        </Panel>
      </Container>
    </VStack>
  );
};

export default NftsPage;
